import { render, staticRenderFns } from "./orders-layout.pug?vue&type=template&id=c72279d0&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./orders-layout.scss?vue&type=style&index=0&id=c72279d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72279d0",
  null
  
)

export default component.exports